import React from 'react';
import PropTypes from 'prop-types';

import ComputerIcon from '@material-ui/icons/Computer';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import ExtensionIcon from '@material-ui/icons/Extension';
import StorageIcon from '@material-ui/icons/Storage';
import TableChartIcon from '@material-ui/icons/TableChart';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import VpnKeyIcon from '@material-ui/icons/VpnKey';

export default function ResourcePolyIcon(props) {
  const { type } = props;
  
  switch(type) {
    case 'Client':
      return (<ComputerIcon {...props}/>);
    case 'Credential':
      return (<VpnKeyIcon {...props}/>);
    case 'Dataset':
      return (<TableChartIcon {...props}/>);
    case 'Datastore':
      return (<StorageIcon {...props}/>);
    case 'LandingZone':
      return (<SystemUpdateAltIcon {...props}/>);
    case 'Stream':
      return (<DoubleArrowIcon {...props}/>);
    case 'Subscription':
      return (<SubscriptionsIcon {...props}/>);
    case 'Workload':
      return (<SettingsApplicationsIcon {...props}/>);
    default:
      return (<ExtensionIcon {...props}/>);
  }
}

ResourcePolyIcon.propTypes = {
  type: PropTypes.string.isRequired,
};

ResourcePolyIcon.defaultProps = {
  type: 'Resource',
};
